export const environment = {
    production: true,
    backendUrl: 'https://api.sideu.osrga.org.ar',
    backendUrlImpo: 'https://api.sideu.osrga.org.ar'
};
